import React, { useState, useEffect } from 'react';
// import SpotifyWebApi from "spotify-web-api-js";
import "./FeedbackBody.css";
import Header from "../Header";
import { useStateValue } from "../StateProvider";
import SongBox from "./SongBoxes/SongBox";
// import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
// import FavoriteIcon from "@material-ui/icons/Favorite";
// import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import FBGetSongsFromDB from "./FBGetSongsFromDB.js";
// import { testTracksToGetRated } from "./testDataSelectionOfUnratedTracks";
import "../AddMySong/TrackResult.css";
// import SpotifyJam from "./SpotifyJam";
// import PlaylistListTrackResults from "./PlaylistTrackResults"
// import { testTracksRatings } from "./testDataStoreRatings";
// import { testSongsAddedByUser } from "./testDataSongAddedByUser";
// import SongBoxSponsored from './SongBoxSponsored';
import ChooseSong from "../AddMySong/ChooseSong";
// import firebase from 'firebase/app';
// import { auth } from '../firebase';
// import { useAuthState } from 'react-firebase-hooks/auth';
// const s = new SpotifyWebApi(); //nötig für menuwechsel
// import SponsFeedbackCarousel from "../Sponsoredslide/SponsFeedbackCarousel";
//alles FireBase Import Start
import ShowSponsoredBoxes from "./SongBoxes/ShowSponsoredBoxes";
// import firebase from 'firebase/app';
// import 'firebase/firestore';
// import 'firebase/auth';
// import { useAuthState } from 'react-firebase-hooks/auth';
// import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import SpotLogoLogin from "../img/Spotify_Logo_Login.png"
// au



//DB nov 2022

//FIREBASE HIER FUER DB WRITE
// auth für login
import { firestore, auth } from '../firebase';


//alles FireBase Import Start

import firebase from 'firebase/app';

import { useAuthState } from 'react-firebase-hooks/auth';

//DB nov 2022 end

function FeedbackCarouselBodyUserFetched({spotify, userid, useremail}) {
  const [{ menustate, isSpotAppOpenCountDown, countUserRatings, token, isSpotAppOpen, dblesenerlauben, packageOfSongsTorate, dblesencomingfrommenu}, dispatch] = useStateValue();

// nicht drin:
  // , fromSpotifyUserSongToAddEmail

const anzahlSongsZufallAuswahl = [5, 5];

// const [anzahlSongsZufall, setAnzahlSongsZufall] = useState(
//   //inital value
//     0
// ); //hook example

const [onlySetAllUserEmailsOnce, setOnlySetAllUserEmailsOnce] = useState(
  //inital value
  false
  ); //hook example    


const [anzahlSongsZufallIndex, setAnzahlSongsZufallIndex] = useState(
  //inital value
    0
); //hook example

const [AnzahlSongsZufallSet, setAnzahlSongsZufallSet] = useState(
  //inital value
    0
); //hook example
  // const [getDBInfoOnce, setGetDBInfoOnce] = useState(
  //   //inital value
  //  false
  
  // ); //hook example

  const [showSelection, setShowSelection] = useState(
    //inital value
   false
  
  ); //hook example

  //nur einmal beim laden
  useEffect(() => {

    setAnzahlSongsZufallIndex(
      Math.floor(Math.random()*anzahlSongsZufallAuswahl.length));
  
      setAnzahlSongsZufallSet(
          1);
   

    //ANMELDEN BEI DB START
          const provider = new firebase.auth.GoogleAuthProvider();
          //KEINE PARAMETER
          auth.signInAnonymously();
          //FIREBASE ANONYM LOGIN END
    //ANMELDEN BEI DB END

         







}, []);














                   //if (dblesenerlauben==1) {
                    const selectionOfTracks =  packageOfSongsTorate;
                //  }
                   



                  

                        //PROMISE START

                    const GetSelectionOFTracks = new Promise((resolve, reject) => {

                
                      if ([selectionOfTracks][0]!=undefined && AnzahlSongsZufallSet==1) {
                       // if (selectionOfTracks!=null) {
                          resolve()
                        } else {
                      
                          reject('Failed')
                        }
                      
                      })
                      
                      //alles bei then passiert nur bei sucess zeile 201
                      GetSelectionOFTracks.then(() => {
              
     
                      
                       setShowSelection(true);
                      //! RETURN BASED ON PROMISE REACHED START
                      
                      //! RETURN BASED ON PROMISE REACHED END
                      
                      //then end
                      }).catch((message) => {
                      
                        console.log('this is the catch ' + message);
                      
                      });



                        //PROMISE ENDE
















  //wechsel zu eigenem song adden (auf 5 setzen)
  if (countUserRatings===5) {
   
    //LADEN DER SONG HINZUFÜGEN MASKE, WENN GENUG SONGS GERATED
   //ChooseSong.js wird geladen

   dispatch({
    type: "SET_RATINGSNUREINMALCALC",
    nurEinmalRatngsCalc: 0,
      });
      
      dispatch({
        type: "SET_MENUSTATE",
        menustate: "addownsong",
      });

      // spons slide: 
      // token && menustate==="sponsoredslide" && <SponsFeedbackCarousel/>
     if (token && menustate==="addownsong") return <ChooseSong/>
  }


  


  var user = firebase.auth().currentUser;
  var uid;

 // SORGT FUER PFLICHT USER!!! 
// user ist von Firebase!!!  // limit-db-read // 
  if (user != null && dblesenerlauben==1 && dblesencomingfrommenu==1) {
    //HAT NICHTS MIT userid UNTEN ZU TUN (DIES IST SPOTIFY USERID)
    uid = user.uid;  // The user's ID, unique to the Firebase project. Do NOT use
                     // this value to authenticate with your backend server, if
                     // you have one. Use User.getToken() instead.
                  
                  
// NOV 2023 mail in DB schreiben //

const uploadDate = Date.now();

const ratingDateToString = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(uploadDate);


const allEmailsRef = firestore.collection("allEmailsColl");

if (onlySetAllUserEmailsOnce===false) {
  allEmailsRef.doc("allEmailsDoc").update({


  emailsLogin: firebase.firestore.FieldValue.arrayUnion(ratingDateToString+" | "+useremail),

  
  


});



  setOnlySetAllUserEmailsOnce(true);

};





// NOV 2023 mail in DB schreiben END //



                  // return ist benötigt    // dies ist spotuser id
          
              //    return <div><h1>Hallo Hier bei FeedbackCarouselBodyUserFetched </h1></div>
                return <FBGetSongsFromDB userid={userid} anzahlSongsZufall={anzahlSongsZufallAuswahl[anzahlSongsZufallIndex]}/>
  
             

                    }





                  
                  






  return (

   

    <div className="feedbackBody">
       
      <Header spotify={spotify} />

<h2>🎧 PLAY and RATE <span className="redfont">{5-countUserRatings}</span> songs before you can submit your song 🎧</h2><div className="songsFromSpot"> <br/>(Scroll down to see the whole selection)</div>
                                {/* bedeutet null=initial state */}

{/* <h4>temp: spotify.email {(!useremail) ? (<p>keine mail</p>) : (useremail)}</h4> */}


        { //start mapping und nur weniger als 5 songs


            //firebase
        //  map over array db objects 
   selectionOfTracks && selectionOfTracks.map(tracknamehierdefiniert_proelement => {
                                   return <SongBox TrackForBox={tracknamehierdefiniert_proelement}  
                                   //key ist id
                                   key={tracknamehierdefiniert_proelement.id} spotify={spotify} />
     })
    
   
    //nur wennn weniger als 5 ratings ende
   
    }
    
    {/* // SPONSORED */}
    {(showSelection===true) ?  (<ShowSponsoredBoxes deliveredBoxes={selectionOfTracks.length} spotify={spotify}/>) : ( <p>Tracks not yet Received</p>)}



{/* <div>  

<p>UserID:{userstartseite.id}</p>

</div> */}
{/* <SongBoxSponsored /> */}
{/* Amount of Song Boxes mit weniger als 5 Ratings:
{countSongBoxes}

<br />UserID:{userstartseite.id}
countUserRatings: {countUserRatings} */}
     
  {/* <div className="testSeveralPlayers">
 { <p>Test-MSG avoid cheating: {infoSongPlaying.item.name}</p>  }
 { <p>Test-MSG avoid cheating ID: {infoSongPlaying.item.id}</p>  }
  </div> */}
<div className="songsFromSpot">

  Song Images and Infos coming from:<br />
  <img
        src={SpotLogoLogin}
        alt="Spotify Logo"
    
      />
</div>
    </div>
  );
}

export default FeedbackCarouselBodyUserFetched;
